<div
  oui-dialog-title
  class="title">
  Mise à jour de la connaissance et expérience
</div>

<div
  oui-dialog-content
  class="content">
  <div class="icon-text">
    <app-qpi-icon-box
      icon="cognition"
      [completed]="data.isComplete"></app-qpi-icon-box>

    <span
      >De nouveaux produits présents dans le recueil d'informations ont été <strong>sélectionnés automatiquement</strong> dans le profil
      investisseur :</span
    >
  </div>

  <ul class="produits">
    @for (produit of data.produitsAjoutes; track produit) {
      <li>{{ produit }}</li>
    }
  </ul>

  @if (!data.isComplete) {
    <span class="warning-emphasis">
      Veuillez répondre aux questions de vérification de ces produits pour finaliser le profil investisseur.
    </span>
  }

  <div class="actions">
    <oui-button
      type="text"
      oui-dialog-close
      >Plus tard</oui-button
    >
    <oui-button (click)="completerQuestionnaire()">Compléter le questionnaire</oui-button>
  </div>
</div>
